import GamePrep from './GamePrep';

export default GamePrep;
